import styled, { css } from "styled-components";
import { colours } from "../../styles/colours.constants";
import { satoshi500, satoshi900 } from "../../styles/font.constants";

export const BasePostStyles = css`
	background-color: ${colours.greyLight};
	border: solid 1px ${colours.greyMedium};
	padding: 1rem;
	border-radius: 0.5rem;
	margin-bottom: 1rem;
`;

export const Post = styled.div`
	${BasePostStyles}
`;

export const BaseTitle = css`
	${satoshi900}
	text-transform: uppercase;
	font-size: 1.25rem;
	margin: 10px 0;
`;

export const Title = styled.div`
	${BaseTitle}
	color: ${colours.black};
`;

export const Text = styled.div`
	${satoshi500}
	color: ${colours.greyDarker};
	line-height: 145%;
`;
